import React, { memo } from "react";
import { PLAYER_HEADSHOT_FALLBACK } from "../../config/constants";

export const RosterCard = memo(({ player, onClick }) => (
  <button
    onClick={onClick}
    className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors w-full text-left"
  >
    <div className="w-10 h-10 rounded-full overflow-hidden bg-gray-200 flex-shrink-0">
      <img
        src={player.headshot_url || PLAYER_HEADSHOT_FALLBACK}
        alt={player.player_name}
        className="w-full h-full object-cover object-top"
        onError={(e) => (e.currentTarget.src = PLAYER_HEADSHOT_FALLBACK)}
      />
    </div>
    <div className="flex-1 min-w-0">
      <div className="font-medium text-gray-900 truncate">{player.player_name}</div>
      <div className="text-xs text-gray-500">{player.position.toUpperCase() || "—"}</div>
    </div>
    <div className="text-right">
      {player.batting_war != null && (
        <div className="text-xs text-gray-600">
          <span className="text-gray-400">bWAR:</span> {player.batting_war?.toFixed(1)}
        </div>
      )}
      {player.pitching_war != null && (
        <div className="text-xs text-gray-600">
          <span className="text-gray-400">pWAR:</span> {player.pitching_war?.toFixed(1)}
        </div>
      )}
    </div>
  </button>
));

RosterCard.displayName = "RosterCard";

